module.exports = __webpack_public_path__ + "d8829184ca93566f041dcebffd14d642.jpg";